import { t } from 'react-switch-lang';
import React from 'react';
import LegalDocPage from '../../components/LegalDocPage';
import { checkSession } from '../../components/Router';
import { LEGAL_DOCUMENTS_LINKS } from '../../utils/Constants';

function CardholderAgreement({ lang }) {
  return (
    <LegalDocPage
      pageTitle={t('PageTitle_Cardholder_Agreement')}
      pageDescription=""
      titleText={t('MyCard_Home_Cardholder_Agreement')}
      docID={LEGAL_DOCUMENTS_LINKS.CARDHOLDER_AGREEMENT}
      lang={lang}
      docNameForAmplitude="Cardholder Agreement"
    />
  );
}

export default checkSession(CardholderAgreement);
export { getStaticPaths, getStaticProps } from '../../utils/DynamicRoutes';
